<template>
  <ValidationProvider
    v-slot="{ errors, required }"
    :vid="control.id"
    :name="control.label"
    :rules="{ required: { allowFalse: false } }"
    :class="control.class"
  >
  <slot name="terms" />

  <div class="flex">
      <bc-checkbox
        class="mt-1"
        :name="control.name"
        :id="control.id"
        :value="true"
        :uncheckedValue="false"
        v-model="model"
      ></bc-checkbox>

      <div class="ml-4">
        I have read and agree to the Specific Terms above and general website <span @click="$root.$refs.agreement.show()" class="underline text-primary-600 hover:text-primary-500 hover:no-underline cursor-pointer">Terms and Conditions</span>  <span class="text-red-500" v-if="required">*</span>
      </div>
    </div>

    <bc-error v-show="errors.length">{{ errors[0] }}</bc-error>
    <bc-note v-if="control.note">{{ control.note }}</bc-note>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
export default {
  name: 'TermsControl',
  components: {
    ValidationProvider
  },
  props: {
    value: {
      type: [Boolean, String, Number],
      default: null
    },
    control: {
      type: Object,
      required: true
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
